export const isExternalLink = (href?: string | null): boolean => {
  if (!href) return false

  // Absolute URLs (http/https) or protocol-relative URLs (//...)
  return href.startsWith('http://') || href.startsWith('https://') || href.startsWith('//')
}

export const stripQueryString = (path: string): string => path.split(/[?#]/)[0]
